module.exports = __webpack_public_path__ + "img/aeroland-digital-store-hero-image-reup.9a65a497.png";